import BaseLayer from './_base/BaseLayer';
import TransitStopsIW from '../../views/transitStopsIW/transitStopsIW';
import { RichMarker } from 'libs/richmarker';

export default BaseLayer.extend({
  /**
   * Create a new TransitStopsLayer instance
   * @memberOf module:Layers
   * @class TransitStopsLayer
   * @classdesc Stops identify on the transit routes.
   * @extends BaseLayer
   * @param {object} options - The needed config to draw the routes on map
   */
  constructor(providedTransitStops, options = {}) {
    options.featureId = 'TransitStopsLayer';
    options.source = {
      id: 'TransitStopsLayer'
    };
    this.providedTransitStops = providedTransitStops;
    BaseLayer.prototype.constructor.call(this, options);
  },

  /**
   * Initialize the layer
   * @memberOf module:Layers.TransitStopsLayer
   * @function
   */
  initialize() {
    this.transitStopsMarkers = [];
    for (let i = 0; i < this.providedTransitStops.length; i++) {
      let departureStop, arrivalStop;
      let beforeStep = this.providedTransitStops[i - 1];
      let currentStep = this.providedTransitStops[i];
      let nextStep = this.providedTransitStops[i + 1];

      if (currentStep.transit && beforeStep && !beforeStep.transit && nextStep && !nextStep.transit) {
        // Current step is a transit step
        // Departure stop
        departureStop = this._getStopInfo(currentStep.transit, 'departure');
        this.transitStopsMarkers.push(this._addMarkerStop(departureStop));
        // Arrival stop
        arrivalStop = this._getStopInfo(currentStep.transit, 'arrival');
        this.transitStopsMarkers.push(this._addMarkerStop(arrivalStop));
      } else if (currentStep.transit && beforeStep && !beforeStep.transit && nextStep && nextStep.transit) {
        // Current and next steps are transit steps
        // Departure stop
        departureStop = this._getStopInfo(currentStep.transit, 'departure');
        this.transitStopsMarkers.push(this._addMarkerStop(departureStop));
        // Commute stop
        arrivalStop = this._getStopInfo(currentStep.transit, 'stop', nextStep.transit);
        this.transitStopsMarkers.push(this._addMarkerStop(arrivalStop));
      } else if (currentStep.transit && beforeStep && beforeStep.transit) {
        // Current and before steps are transit steps
        // Arrival
        arrivalStop = this._getStopInfo(currentStep.transit, 'arrival');
        this.transitStopsMarkers.push(this._addMarkerStop(arrivalStop));
      }
    }
  },

  /**
   * Add the layer
   * @function
   */
  add() {
    for (let i = 0; i < this.transitStopsMarkers.length; i++) {
      this.transitStopsMarkers[i].setMap(this.widget.map);
    }
  },

  /**
   * Deactivate the layer
   * @function
   */
  remove() {
    if (this.transitStopsMarkers.length > 0) {
      this.widget.bus.trigger('CLOSE_INFOWINDOW');
      for (let i = 0; i < this.transitStopsMarkers.length; i++) {
        this.transitStopsMarkers[i].setMap(null);
      }
    }
  },

  _clickHandlerFunction(infowindowProperties, layer) {
    return function(e) {
      e.stopPropagation();
      e.preventDefault();
      layer._clickHandler(infowindowProperties, this);
    };
  },

  _clickHandler(infowindowProperties, marker) {
    let infowindowContent = new TransitStopsIW(infowindowProperties);
    this.widget.bus.trigger('OPEN_INFOWINDOW', marker, this.widget.map, infowindowContent.$el.html());
  },

  _getStopInfo(stop, type, nextStop) {
    let departureStop = 'departure_stop';
    let arrivalStop = 'arrival_stop';
    let departureTime = 'departure_time';
    let arrivalTime = 'arrival_time';
    let numStops = 'num_stops';
    let stopInfo = {
      type: type,
      stopName: type === 'departure' ? stop[departureStop].name : stop[arrivalStop].name,
      departureTime: type === 'departure' ? stop[departureTime] : type === 'arrival' ? false : nextStop[
        departureTime],
      arrivalTime: type === 'arrival' ? stop[arrivalTime] : type === 'departure' ? false : stop[arrivalTime],
      headsign: type === 'departure' ? stop.headsign : type === 'arrival' ? false : nextStop.headsign,
      line: type === 'departure' ? stop.line : type === 'arrival' ? false : nextStop.line,
      totalStops: type === 'departure' ? stop[numStops] : type === 'arrival' ? false : nextStop[numStops],
      location: type === 'departure' ? stop[departureStop].location : stop[arrivalStop].location
    };

    if (stopInfo.departureTime) {
      let startTimeOffset = this._getTimeOffset(stopInfo.departureTime.value, stopInfo.departureTime.text);
      stopInfo.departureTime = this._normalizeTime(this._getTimeInLocalGMT(stopInfo.departureTime.value,
        startTimeOffset));
    }
    if (stopInfo.arrivalTime) {
      let endTimeOffset = this._getTimeOffset(stopInfo.arrivalTime.value, stopInfo.arrivalTime.text);
      stopInfo.arrivalTime = this._normalizeTime(this._getTimeInLocalGMT(stopInfo.arrivalTime.value,
        endTimeOffset));
    }

    return stopInfo;
  },

  _getTimeOffset(time, text) {
    let hour = parseInt(text.split(':')[0]);
    if (text.split(':')[1].substring(2, 4) === 'pm' && hour !== 12) {
      hour += 12;
      if (hour === 24) {
        hour = 0;
      }
    }
    return (hour - time.getHours()) * 60;
  },

  _getTimeInLocalGMT(time, timezoneOffset) {
    let newTime = time.valueOf() + timezoneOffset * 60000;
    return new Date(newTime);
  },

  _normalizeTime(time) {
    return time.getHours() + ':' + (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes());
  },

  _addMarkerStop(stopInfo) {
    let marker = new RichMarker({
      shadow: 'none',
      content: '<div class="lmm-marker-transit-stop ' + stopInfo.type + '"></div>',
      position: stopInfo.location,
      zIndex: 10
    });

    google.maps.event.addListener(marker, 'click', this._clickHandlerFunction(stopInfo, this));

    return marker;
  }
});



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/types/TransitStopsLayer.js